import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./Home.css";
import Services from "../Home/Services";
import About from "../Home/AboutUs";
import Testimonials from "../Home/Testimonials";
import ReachUs from "../Home/ReachUs";
import Footer from "../Home/Footer";
import Templates from "../Home/Templates";
import CarouselCards from "../Home/CarouselCards";
import Static from "../Home/Templates/Static";
import Dynamic from "../Home/Templates/Dynamic";
import Responsive from "../Home/Templates/Responsive";
import Personalized from "../Home/Templates/Personalised";
import Pricing from "../Home/Pricing";

function Home() {
  const [selectedTemplate, setSelectedTemplate] = useState("static");
  const scrollToServices = () => document.getElementById("fff")?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <section id="header" className="hero-section">
        <div className="hero-overlay" aria-hidden="true" />
        <div className="hero-content hero-content-single">
          <div className="header-text">
            <span className="hero-badge">AI-powered websites for local businesses</span>
            <h1>
              Get your business <span>online</span>
              <br />in 48 hours
            </h1>
            <p className="hero-subtitle">
              Professional websites for shops, salons, clinics &amp; restaurants.
              Mobile-ready, WhatsApp-enabled, starting at <strong>₹2,500</strong>.
            </p>
            <div className="hero-cta-buttons">
              <button type="button" className="hero-btn-primary" onClick={scrollToServices}>
                Explore Services
              </button>
              <a
                href="https://wa.me/919392014678?text=Hi!%20I%20want%20a%20website"
                className="hero-btn-whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <CarouselCards />
      <Services />
      <Templates handleTemplateChange={setSelectedTemplate} selectedTemplate={selectedTemplate} />
      {selectedTemplate === "static" && <Static />}
      {selectedTemplate === "dynamic" && <Dynamic />}
      {selectedTemplate === "responsive" && <Responsive />}
      {selectedTemplate === "personalized" && <Personalized />}
      <Pricing />
      <About />
      <Testimonials />
      <ReachUs />
      <Footer />
    </>
  );
}

export default Home;
